<template>
  <div>
    <h1 class="page-header">{{ $t('schoolcontact.schoolcontact') }}</h1>
    <div class="row">
      <div
        v-show="isStaff"
        class="col-md-3 col-sm-12"
        :class="{ 'col-lg-3': isStaff }"
      >
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('schoolcontact.contactName')
              }}</label>
              <input
                v-model="model.contact_name"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('contact_name') }"
                placeholder="Enter contact name"
              />
              <div class="invalid-feedback" v-if="errors.has('contact_name')">
                {{ errors.first('contact_name') }}
              </div>
            </div>
            <div class="form-group">
              <label class="required">{{ $t('schoolcontact.position') }}</label>
              <ts-loading-banner :loading="loadingPreData">
                <select
                  v-model.number="model.position_id"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('position_id') }"
                >
                  <option value="">{{ $t('select') }}</option>
                  <option
                    v-for="(position, index) in positions"
                    :key="index"
                    :value="position.position_id"
                  >
                    {{ position.pos_name_en }}
                  </option>
                </select>
              </ts-loading-banner>
              <div class="invalid-feedback" v-if="errors.has('position_id')">
                {{ errors.first('position_id') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('schoolcontact.phoneNumber')
              }}</label>
              <input
                v-model="model.phone_number"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('phone_number') }"
                placeholder="Enter phone number"
              />
              <div class="invalid-feedback" v-if="errors.has('phone_number')">
                {{ errors.first('phone_number') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{ $t('schoolcontact.email') }}</label>
              <input
                v-model="model.email"
                type="email"
                class="form-control"
                :class="{ 'is-invalid': errors.has('email') }"
                placeholder="Enter email address"
              />
              <div class="invalid-feedback" v-if="errors.has('email')">
                {{ errors.first('email') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('schoolcontact.priorityLevel')
              }}</label>
              <input
                v-model.number="model.level_priority"
                type="number"
                class="form-control"
                :class="{ 'is-invalid': errors.has('level_priority') }"
                placeholder="Enter priority level"
              />
              <div class="invalid-feedback" v-if="errors.has('level_priority')">
                {{ errors.first('level_priority') }}
              </div>
            </div>
            <div class="text-right">
              <ts-button v-if="updating" class="mr-2" @click.prevent="cancel">
                {{ $t('cancel') }}
              </ts-button>
              <ts-button
                v-if="updating"
                class="btn-primary"
                :waiting="waiting"
                @click.prevent="update"
              >
                {{ $t('update') }}
              </ts-button>
              <ts-button
                v-if="!updating"
                :waiting="waiting"
                class="btn-primary"
                @click.prevent="store"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div
        class="col-lg-9 col-md-9 col-sm-12"
        :class="{ 'col-lg-12': !isStaff }"
      >
        <data-table :fetch="fetch" @fetched="fetch = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DataTable from './table'
import { Errors } from 'form-backend-validation'

export default {
  name: 'school-contact-form',
  components: {
    DataTable
  },
  data() {
    return {
      model: {
        scc_id: '',
        contact_name: '',
        position_id: '',
        phone_number: '',
        level_priority: ''
      },
      errors: new Errors(),
      waiting: false,
      fetch: false,
      loadingPreData: false,
      updating: false
    }
  },
  created() {
    if (this.isStaff) {
      this.fetchResourceBeforeCreate()
    }
  },
  computed: {
    ...mapState('schoolContact', ['edit_data', 'positions']),
    isStaff() {
      return this.$store.getters.isStaffLogin
    }
  },
  methods: {
    fetchResourceBeforeCreate() {
      this.loadingPreData = true
      this.$store
        .dispatch('schoolContact/dataBeforeCreate')
        .then(() => {
          this.loadingPreData = false
          this.setEditData()
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('schoolContact/store', this.model)
        .then(response => {
          this.clearInput()
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('schoolContact/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },

    cancel() {
      this.updating = false
      this.$store.commit('schoolContact/SET_EDIT_DATA', {})
      this.$router.push({ name: 'school-contact' })
      this.clearInput()
    },
    clickBackURL() {
      this.$store.commit('schoolContact/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetch = true
      this.updating = false
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.errors = new Errors()
        this.model = _.clone(this.edit_data)
        this.updating = true
      }
    },
    clearInput() {
      this.model = {
        scc_id: '',
        contact_name: '',
        position_id: '',
        phone_number: '',
        level_priority: ''
      }
    }
  },
  watch: {
    edit_data: {
      handler() {
        this.setEditData()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('schoolContact/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
